import cn from "classnames"

import { KodemScoreIcon } from "@/icons"

import styles from "./KodemScoreCell.module.scss"

export const KodemScore = ({
  score,
  underline
}: {
  score: number
  underline?: boolean
}) => (
  <div className={styles.scoreContainer}>
    <KodemScoreIcon score={score} />
    <span className={cn(styles.score, underline && styles.scoreUnderline)}>
      {score}
    </span>
  </div>
)
